import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

import "@/plugins/elementUI";
import "@/plugins/globalPrototype";
import "@/plugins/globalComponents";

import "@/assets/scss/index.scss";

// 自定义指令
import "@/directive/index";

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  render: h => h(App),
});
